export function createFileReader(): FileReader {
  return new FileReader();
}
